// Google Analytics Universal Analytics (UA) was shut down July 2024.
// GA4 tracking is handled via gtag in index.html (G-SDMW6NKEVC, OOH-owned).
// This module is a no-op stub to avoid breaking 59 files that import appAnalytics.

class AppAnalytics {
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  pageview(_location: { pathname: string; search: string }) {}
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  event(_data: EventData) {}
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  set(_data: any) {}
}

interface EventData {
  category: string
  action: string
  value?: number
  nextPath?: string
  featured?: string | boolean
  conversationId?: number
}

const appAnalytics = new AppAnalytics()
export default appAnalytics
